import {
  CcfBox,
  CcfHistoryIcon,
  CcfNoRequestFoundIcon,
  CcfTypography,
  useTranslator,
} from '@nice-ccf/ui-controls';
import styles from './ccf-wem-dashboard.module.scss';
import { makeStyles } from '@mui/styles';
import { MenuItem, Select } from '@mui/material';
import { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';

/* eslint-disable-next-line */
export interface CcfWemCoachingRequestTabProps {
  isRequestClicked: any;
  setIsRequestClicked: any;
  requestRowData: any;
}

const useStyles = makeStyles({
  root: {
    '& .MuiDataGrid-root': {
      border: '1px solid rgba(251, 252, 252, 1)',
      Height: '330px',
    },

    '& .MuiDataGrid-columnHeaderTitleContainer': {
      padding: '0px',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '16px',
      textTransform: 'uppercase',
      color: '#526B79',
    },
    '& .MuiDataGrid-columnsContainer': {
      background: '#FFFFF',
      border: '1px solid #D2D8DB',
      boxShadow: '0px 3px 4px rgba(0, 0, 0, 0.08)',
    },
    '& .styledrows': {
      height: '36px',
      background: '#FFFFF',
      border: '1px solid #D2D8DB',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '13px',
      lineHeight: '18px',

      color: '#333333',

      /* Inside auto layout */
    },
    // '& .MuiDataGrid-window': {
    //   height: '285px',
    //   overflowY: 'scroll',
    // },
  },
  searchInput: {
    '&.MuiOutlinedInput-input': {
      padding: '5px',
    },
    // '&.MuiOutlinedInput-inputAdornedEnd': {
    //   paddingBottom: '7.5px',
    // },
  },
});

/**
 * CcfWemEvaluations - used to display wem evaluations
 * @param props - CcfWemEvaluations
 * @example `<CcfWemEvaluations />`
 */
export function CcfWemCoachingRequestTab(props: CcfWemCoachingRequestTabProps) {
  const { isRequestClicked, setIsRequestClicked, requestRowData } = props;
  const classes = useStyles();
  const [translate] = useTranslator();
  const [rowData, setRowData]: any = useState([]);
  const [dropdownData, setDropdownData] = useState('Current Quarter');

  const columns = [
    {
      field: 'focusArea',
      headerName: 'focus area'.toUpperCase(),
      width: 130,
    },
    {
      field: 'coachName',
      headerName: 'coach name'.toUpperCase(),
      width: 150,
    },
    {
      field: 'lastUpdated',
      headerName: 'last updated'.toUpperCase(),
      width: 130,
    },
    {
      field: 'creadedOn',
      headerName: 'creaded on'.toUpperCase(),
      width: 130,
    },
    {
      field: 'status',
      headerName: 'staus'.toUpperCase(),
      width: 150,
      renderCell: (params: any) => (
        <CcfBox
          style={{ display: 'flex', alignItems: 'flex-start', gap: '3px' }}
        >
          <CcfHistoryIcon />
          {params.value}
        </CcfBox>
      ),
    },
  ];
  useEffect(() => {
    setRowData([...requestRowData]);
  }, [requestRowData]);
  /**
   * Handles the change event for input elements.
   * Updates the form data with the new value.
   * @param e - The change event.
   * @example
   */
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setDropdownData(value);
  };

  /**
   *
   * @example - noDataFound()
   */
  const noRequestFound = () => {
    return (
      <CcfBox className={styles.tableDataContainer}>
        <CcfBox className={styles.noDataFoundBlock}>
          <CcfNoRequestFoundIcon style={{ fontSize: 240 }} />
          <CcfTypography className={styles.noRequestTxt}>
            No request was created yet
          </CcfTypography>
        </CcfBox>
      </CcfBox>
    );
  };

  return (
    <CcfBox>
      <CcfBox
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #d0d2d3',
        }}
      >
        <CcfBox className={styles.sessionTabSearchBar}>
          <CcfBox
            className={styles.searchCountText}
          >{`${rowData.length} requests`}</CcfBox>
        </CcfBox>
        <CcfBox
          className={styles.sessionTabSearchBar}
          sx={{ display: 'flex', justifyContent: 'flex-end' }}
        >
          <CcfTypography style={{ fontWeight: '600', fontSize: '12px' }}>
            LAST UPDATED
          </CcfTypography>
          <CcfBox>
            <Select
              id={'selectControl'}
              className={styles.selectControl}
              name={dropdownData}
              value={dropdownData}
              onChange={(e: any) => handleChange(e)}
            >
              {[
                translate('currentMonth'),
                translate('previousMonth'),
                translate('currentQuarter'),
                translate('previousQuarter'),
                translate('previous12Month'),
              ].map((x: any) => (
                <MenuItem
                  key={x}
                  value={x}
                  style={{ fontSize: '13px', color: '#2e2e2e' }}
                >
                  {x}
                </MenuItem>
              ))}
            </Select>
          </CcfBox>
        </CcfBox>
      </CcfBox>

      <CcfBox
        style={{
          height: '63vh',
          backgroundColor: '#f2f7fa',
          overflowY: 'hidden',
          borderTop: '1px solid #E1E1E1',
        }}
        id={`agent_wem_req_dataGridContainer`}
      >
        <DataGrid
          classes={{ root: classes.root }}
          rows={rowData}
          columns={columns}
          rowHeight={40}
          getRowId={(row: any) => row?.id}
          pageSize={10}
          headerHeight={40}
          // autoHeight
          disableSelectionOnClick
          pagination
          rowsPerPageOptions={[5, 10, 25]}
          getRowClassName={(params: any) => `styledrows`}
          sx={{
            '& .MuiDataGrid-columnHeaderTitle': {
              color: '#3F5C69',
              fontWeight: '600',
              fontSize: '12px',
              fontFamily: 'Open Sans',
            },
          }}
          components={{
            NoRowsOverlay: () => noRequestFound(),
          }}
        />
      </CcfBox>
    </CcfBox>
  );
}
